import { Component, OnInit } from '@angular/core';
import { WEB_USER_URL } from '../../constants/config';

@Component({
  selector: 'footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  showFooter: boolean = false;
  constructor() { }

  ngOnInit() {
    setTimeout(() => {
      this.showFooter = true;
    }, 1000);
  }

  viewPage(page) {
    window.open(`${WEB_USER_URL}${page}/`, '_blank');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/footer/footer.component.ts